import { categories } from '@/mocks/comics';

const quickLinks = [
  { label: '分类精选', href: '#categories' },
  { label: '爆笑连载', href: '#comics' },
  { label: '今日热门', href: '#hot' },
  { label: '小编推荐', href: '#picks' },
  { label: '常见问题', href: '#faq' },
  { label: '关于本站', href: '#about' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-primary-100" aria-label="页脚">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
                <i className="ri-emotion-laugh-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-background-50 md:text-2xl">哈哈漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              汇集全网搞笑漫画与爆笑漫画合集，每日更新热门搞笑条漫，一键追更不迷路，专治不开心，笑到肚子疼。
            </p>
            <div className="mt-5 flex gap-2">
              {['ri-wechat-fill', 'ri-weibo-fill', 'ri-tiktok-fill', 'ri-mail-fill'].map((ic) => (
                <a
                  key={ic}
                  href="#contact"
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-800 text-lg text-primary-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                  aria-label={ic}
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* quick nav */}
          <nav aria-label="快速导航">
            <h3 className="font-heading text-base text-background-50">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-primary-200 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* categories */}
          <nav aria-label="热门分类">
            <h3 className="font-heading text-base text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories
                .filter((c) => c.key !== 'all')
                .map((c) => (
                  <li key={c.key}>
                    <a href="#comics" className="text-sm text-primary-200 transition-colors hover:text-background-50">
                      {c.name}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>

          {/* contact */}
          <div>
            <h3 className="font-heading text-base text-background-50">联系与投稿</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" aria-hidden="true"></i>
                contribute@haha-comics.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line" aria-hidden="true"></i>
                每日 09:00 - 22:00 在线
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-emotion-laugh-line" aria-hidden="true"></i>
                投稿一经采用，立刻署名上线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 sm:flex-row">
          <p className="text-xs text-primary-300">
            © {new Date().getFullYear()} 哈哈漫画网 · 让每个不开心都被治愈
          </p>
          <p className="text-xs text-primary-300">仅供娱乐阅读 · 尊重原创作者版权</p>
        </div>
      </div>
    </footer>
  );
}